<p-panel #primePanel class="collapsible-panel" [toggleable]="true" (onAfterToggle)="onAfterToggle($event)">
  <p-header class="collapsible-panel__header">
    <ng-content select="header"></ng-content>
  </p-header>
  <ng-content></ng-content>
</p-panel>
